import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import ScrollOut from "scroll-out";
import { NewsService } from 'src/app/services/news/news.service';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit,OnDestroy {

  so:any;
  news:any[];
  sub:Subscription[]=[];
  constructor(private newsService:NewsService) { }

  ngOnInit(): void {
    this.so = ScrollOut({
      onShown: function(el) {
        // remove the class
        el.classList.remove('animated');
    
        // force reflow
        void el.offsetWidth;
    
        // re-add the animated cl
        el.classList.add('animated');
      }
    });

    this.newsService.getNewsList();
    this.sub[0]= this.newsService.newsList.snapshotChanges().subscribe(
      list=>{
      this.news=  list.map(item=>{  return {
        $key:item.key,
        ... item.payload.val()
      }});
      this.news=this.news.reverse();
      }
      
      );
  }
  
  ngOnDestroy(){
    this.so.teardown();
    this.sub.forEach(s=>s.unsubscribe());
  }

}
